// Commercial — Wrapper widget pour PipelineDistributionFunnel
// (Répartition Pipeline Cible sur les 10 étapes gouvernance, déjà
// componentized dans pages/commercial/PipelineDistributionFunnel.jsx).
import PipelineDistributionFunnel from "../../pages/commercial/PipelineDistributionFunnel";

export default function CommercialDistributionFunnelWidget() {
  // Le composant existant gère son propre fetch et son rendu — on le
  // réutilise tel quel pour ne pas dupliquer. Il prendra le tenant via
  // ses propres mécanismes internes.
  return <PipelineDistributionFunnel tenantId={null} />;
}
